

    var $ = require('@alife/alpha-jquery/jquery'),
        gdata = require('@alife/alpha-gdata/gdata');

    var undefinedVar;

    if(gdata.get('domdot-datainit') === undefinedVar){
        gdata.define('domdot-datainit', 'ready');
    }

    var defSettings = {
        event: 'mousedown',
        params: '',
        delegate: ''
    };

    var regParams = /^(sid|pid|mn|ext)$/;

    // 打点公共参数
    var commonParams = {};

    // 设置打点公共参数
    function setCommonParams(key, value){
        if(key && regParams.test(key)){
            commonParams[key] = value;
        }
    }

    // 返回打点公共参数
    function getCommonParams(key){
        var value = commonParams[key],
            type = $.type(value);
        if( type === 'object' || type === 'array'){
            value = $.extend(true, {}, value);
        }
        return value;
    }

    function addDot(target, id, options){
        var arrDots = target['domdot-dots'];
        if( !arrDots ){
            arrDots = [];
            target['domdot-dots'] = arrDots;
        }
        var targetData = $.extend(true, {}, defSettings, options, {'id': id, 'count': 0} );
        targetData.handle = function(e){
            // mousedown和mouseup只在鼠标左键时触发
            if(/^mouse(down|up)$/.test(e.type) === true && e.button === 2){
                return;
            }
            var node = this;
            if(dotstat(targetData.id, getDotParams(targetData, e), node)){
                targetData.count ++;
            }
        };
        if(targetData.delegate !== ''){
            $(target).on(targetData.event, targetData.delegate, targetData.handle);
        }
        else{
            addEvent(target, targetData.event, targetData.handle);
        }
        arrDots.push(targetData);
        return true;
    }

    // 抽取打点参数，扩展通用打点参数
    function getDotParams(targetData, e){
        var dotParams = {};
        for(var key in targetData){
            if(regParams.test(key) || /^(params|cache)$/.test(key)){
                dotParams[key] = targetData[key];
            }
        }
        var doc = document.documentElement,
            body = document.body;
        var viewHeight = window.innerHeight || (doc && doc.clientHeight) || body.clientHeight;
        var pageY = e.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
        var screenNo = parseInt(pageY/viewHeight, 10) + 1;// 第几屏
        var ext = dotParams.ext || '';
        ext += (ext!==''?'|':'')+'screen='+ screenNo;
        dotParams.ext = ext;
        return dotParams;
    }

    // 原生绑定事件
    function addEvent( obj, type, fn ) {
        if ( obj.attachEvent ) {
            var eventHandle = obj[type+fn] = function(){
                fn.call(obj, window.event );
            };
            obj.attachEvent( 'on'+type, eventHandle );
        } else{
            obj.addEventListener( type, fn, false );
        }
    }
    // 解除事件绑定
    function removeEvent( obj, type, fn ) {
        if ( obj.detachEvent ) {
            var eventId = type+fn;
            obj.detachEvent( 'on'+type, obj[eventId] );
            obj[eventId] = null;
        } else{
            obj.removeEventListener( type, fn, false );
        }
    }

    function removeDot(target, id, options){
        var arrDots = target['domdot-dots'];
        if( !arrDots ) {
            return false;
        }

        var targetData = $.extend(true, {}, defSettings, options );

        var result = false, dotData;
        for(var i=0;i<arrDots.length;i++){
            dotData = arrDots[i];
            if( dotData.id === id &&
                dotData.event === targetData.event
                ){
                    if(dotData.delegate !== ''){
                        $(target).off(dotData.event, targetData.delegate, dotData.handle);
                    }
                    else{
                        removeEvent(target, dotData.event, dotData.handle);
                    }
                    arrDots.splice( i--, 1 );
                    result = true;
            }
        }
        return result;
    }

    // 发送打点
    function dotstat(id, objParams, target){
        var dmtrack = window.dmtrack;
        if(dmtrack && dmtrack.dotstat){
            var allParams = $.extend(true, {}, commonParams),
                otherParams, val;
            var mapExt, key;
            for(key in objParams){
                val = objParams[key];
                if(key === 'ext'){
                    if(allParams[key] === undefinedVar){
                        allParams['ext'] = {};
                    }
                    mapExt = allParams['ext'];
                    val.replace(/(\w+)\s*=\s*(.*?)(\||$)/g, function(all, key, value){
                        mapExt[key] = value;
                    });
                }
                else if( key === 'params' && val !== '' ){
                    otherParams = val;
                }
                else if(regParams.test(key) === true){
                    allParams[key] = val;
                }
            }
            var arrParams = [], arrExt;
            for(key in allParams){
                if(key === 'ext'){
                    mapExt = allParams[key];
                    arrExt = [];
                    for(var extKey in mapExt){
                        arrExt.push(extKey+'='+mapExt[extKey]);
                    }
                    arrParams.push(key+'='+arrExt.join('|'));
                }
                else{
                    arrParams.push(key+'='+allParams[key]);
                }
            }
            if(otherParams){
                arrParams.push(otherParams);
            }
            var strParams = arrParams.join('&');
            strParams = strParams.replace(/\{\{(\w+)(?:\s+([^\s]+?))?(?:\s+([^\s]+?))?\}\}/g, function(all, cmd, param1, param2){
                var jTarget, paramValue = null;
                cmd = cmd.toLowerCase();
                try{
                    switch(cmd){
                        case 'js':
                            paramValue = eval(param1);
                            break;
                        case 'attr':
                            jTarget = $(param2?'#'+param1:target);
                            if(jTarget.length > 0){
                                paramValue = jTarget.attr(param2?param2:param1);
                            }
                            break;
                        case 'text':
                            jTarget = $(param1?'#'+param1:target);
                            if(jTarget.length > 0){
                                paramValue = jTarget.text();
                            }
                            break;
                        case 'data':
                            jTarget = $(target);
                            if(jTarget.length > 0 && param1){
                                paramValue = jTarget.data(param1);
                            }
                            break;
                    }
                }
                catch(e){
                    return '';
                }
                if(paramValue !== null){
                    return encodeURIComponent(paramValue);
                }
                else{
                    return '';
                }
            });
            var bCache = objParams && objParams.cache,
                jTarget = $(target);
            if(jTarget.length === 1 && bCache === undefinedVar){
                // target非_blank，且href非javascript与#锚点协议的超链接默认开启缓存模式
                var sHref = jTarget.attr('href') || '',
                    sTarget = jTarget.attr('target') || '';
                sHref = sHref.replace(location.href,'');
                var match = sHref.match(/^\s*(\w+):/),
                    protocol = match && match[1] || '';
                bCache = target.tagName === 'A' && sHref != '' && ((protocol == '' && /^#.*/.test(sHref) === false) || /^https?$/i.test(protocol)) && /^\s*_blank\s*$/i.test(sTarget) === false;
            }
            bCache = bCache === true || bCache === 'true';
            dmtrack.dotstat(id, strParams, bCache);
            return true;
        }
        return false;
    }

    // 解析data中的mini json数据
    function parseData(str){
        var arrDatas = [],
            objData = {};
        str.replace(/\s*(\w+)\s*:\s*(?:\'(.*?[^\\])\'|\"(.*?[^\\])\"|(.+?))\s*(\|\||,|$)/g, function(a, key, v1, v2 ,v3 ,split){
            objData[key] = v1 || v2 || v3;
            if(split === '||'){
                arrDatas.push(objData);
                objData = {};
            }
        });
        arrDatas.push(objData);
        return arrDatas;
    }

    // 设置打点公共参数
    exports.setCommonParams = setCommonParams;
    // 读取打点公共参数
    exports.getCommonParams = getCommonParams;

    // 添加打点
    exports.add = function(targets, id, options){
        var jTargets = $(targets),
            allResult = true,
            result;
        if(jTargets.length === 0){
            return false;
        }
        for(var i=0,c=jTargets.length;i<c;i++){
            result = addDot(jTargets[i], id, options);
            if(result === false){
                allResult = false;
            }
        }
        return allResult;
    };

    // 移除打点
    exports.remove = function(targets, id, options){
        var jTargets = $(targets),
            allResult = true,
            result;
        if(jTargets.length === 0){
            return false;
        }
        for(var i=0,c=jTargets.length;i<c;i++){
            result = removeDot(jTargets[i], id, options);
            if(result === false){
                allResult = false;
            }
        }
        return allResult;
    };

    // 封装过的打点API，具有合并打点公共参数功能
    exports.dotstat = dotstat;

    // 初始化data打点
    exports.initDataDots = function(){
        var arrDomdotTargets = $('[data-domdot]'),
            target, arrDataDomdots, dataDomdot;
        for(var i=0,c1=arrDomdotTargets.length;i<c1;i++){
            target = arrDomdotTargets[i];
            // 已初始化的DOM不进行重复初始化
            if(target['domdot-dots']){
                continue;
            }
            arrDataDomdots = parseData(target.getAttribute('data-domdot'));
            for(var j=0,c2=arrDataDomdots.length;j<c2;j++){
                dataDomdot = arrDataDomdots[j];
                addDot(target, dataDomdot.id, dataDomdot);
            }
        }
    };

    // 获得当前页面所有打点
    exports.getAllDots = function(){
        // 将所有 自动委托打点 转换为 非委托打点
        exports.initDataDots();
        var jAllDom = $('*'), dom,
            arrAllDots = [],
            arrDots, dot;
        for(var i=0,c1=jAllDom.length;i<c1;i++){
            dom = jAllDom[i];
            arrDots = dom['domdot-dots'];
            if(arrDots){
                for(var j=0,c2=arrDots.length;j<c2;j++){
                    dot = arrDots[j];
                    arrAllDots.push(dot);
                }
            }
        }
        return arrAllDots;
    };

    $(function(){

        // ready初始化data打点
        if(gdata.get('domdot-datainit') === 'ready'){
            exports.initDataDots();
        }

        // 防止同一个页面下组件多次初始化
        if(window._domdotInited !== true){
            window._domdotInited = true;
            // 自动委托打点
            $('body').on('mousedown click', function(e){
                var eventType = e.type,
                    jAllDotDoms = $(e.target).closest('[data-domdot]'),
                    node, arrDataDomdots, dotid, dataDomdot;
                for(var i=0,c1=jAllDotDoms.length;i<c1;i++){
                    node = jAllDotDoms[i];
                    //忽略已初始化非委托的节点
                    if(node['domdot-dots']){
                        continue;
                    }
                    arrDataDomdots = parseData(node.getAttribute('data-domdot'));
                    for(var j=0,c2=arrDataDomdots.length;j<c2;j++){
                        dataDomdot = arrDataDomdots[j];
                        dataDomdot = $.extend(true, {}, defSettings, dataDomdot);
                        dotid = dataDomdot.id;
                        if(eventType === dataDomdot.event && dataDomdot.id){
                            dotstat(dotid, getDotParams(dataDomdot, e), node);
                        }
                    }
                }
            });
        }
    });

    $(window).bind('load',function(){
        // load初始化data打点
        if(gdata.get('domdot-datainit') === 'load'){
            // 延迟100毫秒初始化
            setTimeout(exports.initDataDots, 100);
        }
    });

